import { defineMessages } from "./define";

/**
 * The folder and team screens. Each phrase the shared tree panel builds from
 * a noun has one key per kind, so English is free to order the words its own
 * way rather than inheriting the Japanese "{noun}名" construction.
 */
export const organisation = defineMessages({
  ja: {
    "organisation.folder.heading": "フォルダ",
    "organisation.folder.namePlaceholder": "フォルダ名",
    "organisation.folder.newNameLabel": "新しいフォルダの名前",
    "organisation.folder.empty": "フォルダはまだありません",
    "organisation.folder.selectPrompt":
      "フォルダを選ぶと、ここに中身が表示されます。",
    "organisation.folder.renameTitle": "フォルダ名を変更",
    "organisation.folder.nameLabel": "フォルダ名",
    "organisation.folder.moveDescription":
      "移動先のフォルダを選んでください。配下のフォルダも一緒に移動します。",
    "organisation.team.heading": "チーム",
    "organisation.team.namePlaceholder": "チーム名",
    "organisation.team.newNameLabel": "新しいチームの名前",
    "organisation.team.empty": "チームはまだありません",
    "organisation.team.selectPrompt":
      "チームを選ぶと、ここに中身が表示されます。",
    "organisation.team.renameTitle": "チーム名を変更",
    "organisation.team.nameLabel": "チーム名",
    "organisation.team.moveDescription":
      "移動先のチームを選んでください。配下のチームも一緒に移動します。",

    "organisation.tree.addUnder": "{name} の下に追加",
    "organisation.tree.clearSelection": "選択を解除（最上位に追加）",
    "organisation.tree.deleteTitle": "{name} を削除",
    "organisation.tree.deleteDescription": "この操作は取り消せません。",
    "organisation.tree.renameSubmit": "変更",
    "organisation.tree.moveTitle": "{name} を移動",
    "organisation.tree.moveDestination": "移動先",
    "organisation.tree.topLevel": "（最上位）",

    "organisation.folders.title": "フォルダ管理",
    "organisation.folders.noContracts":
      "このフォルダに契約書はありません。契約書の詳細画面から移動できます。",

    "organisation.teams.title": "チーム管理",
    "organisation.teams.adminTeamNote":
      "このチームのメンバーは管理者として、フォルダ・チーム・所属を変更できます。",
    "organisation.teams.addMembersBefore": "メンバーの追加は ",
    "organisation.teams.addMembersLink": "ユーザー管理",
    "organisation.teams.addMembersAfter":
      " から行います。一度もログインしていない人はチームに追加できません。",
    "organisation.teams.noMembers": "メンバーはまだいません。",
    "organisation.teams.removeTitle": "{email} をチームから外す",
    "organisation.teams.removeDescription": "{team} のメンバーから外します。",
  },
  en: {
    "organisation.folder.heading": "Folders",
    "organisation.folder.namePlaceholder": "Folder name",
    "organisation.folder.newNameLabel": "New folder name",
    "organisation.folder.empty": "No folders yet",
    "organisation.folder.selectPrompt":
      "Select a folder to see what is in it here.",
    "organisation.folder.renameTitle": "Rename folder",
    "organisation.folder.nameLabel": "Folder name",
    "organisation.folder.moveDescription":
      "Choose where to move it. Folders inside it move along with it.",
    "organisation.team.heading": "Teams",
    "organisation.team.namePlaceholder": "Team name",
    "organisation.team.newNameLabel": "New team name",
    "organisation.team.empty": "No teams yet",
    "organisation.team.selectPrompt": "Select a team to see its members here.",
    "organisation.team.renameTitle": "Rename team",
    "organisation.team.nameLabel": "Team name",
    "organisation.team.moveDescription":
      "Choose where to move it. Teams under it move along with it.",

    "organisation.tree.addUnder": "Add under {name}",
    "organisation.tree.clearSelection": "Clear selection (add at top level)",
    "organisation.tree.deleteTitle": "Delete {name}",
    "organisation.tree.deleteDescription": "This cannot be undone.",
    "organisation.tree.renameSubmit": "Rename",
    "organisation.tree.moveTitle": "Move {name}",
    "organisation.tree.moveDestination": "Move to",
    "organisation.tree.topLevel": "(Top level)",

    "organisation.folders.title": "Folders",
    "organisation.folders.noContracts":
      "There are no contracts in this folder. You can move one here from its contract page.",

    "organisation.teams.title": "Teams",
    "organisation.teams.adminTeamNote":
      "Members of this team are administrators and can change folders, teams and memberships.",
    "organisation.teams.addMembersBefore": "Add members from ",
    "organisation.teams.addMembersLink": "Users",
    "organisation.teams.addMembersAfter":
      ". People who have never signed in cannot be added to a team.",
    "organisation.teams.noMembers": "No members yet.",
    "organisation.teams.removeTitle": "Remove {email} from the team",
    "organisation.teams.removeDescription":
      "{email} will no longer be a member of {team}.",
  },
});
